import { Box, BoxProps } from "@chakra-ui/react";
import { ShoppingThickIcon } from "../../icons/ShoppingThickIcon";

interface LockedContentBadgeProps extends BoxProps {}

export function LockedContentBadge({
  boxSize,
  ...props
}: LockedContentBadgeProps) {
  return (
    <Box padding={2} background="transparent" borderWidth={0} {...props}>
      <ShoppingThickIcon boxSize={boxSize ?? "16px"} color="info.300" />
    </Box>
  );
}
